import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn, Router } from '@angular/router';
import { LoadingService } from '@mds/ngx-core';
import { EMPTY, finalize, first } from 'rxjs';
import { ShiftResponse, ShiftsClient } from '../../shared';

export const shiftResolver: ResolveFn<ShiftResponse> = (
  route: ActivatedRouteSnapshot,
) => {
  const shiftsClient = inject(ShiftsClient);
  const loadingService = inject(LoadingService);
  const router = inject(Router);

  const shiftId = Number(route.paramMap.get('shiftId'));

  if (Number.isNaN(shiftId)) {
    void router.navigate(['shifts']);
    return EMPTY;
  }

  loadingService.start();

  return shiftsClient.getShiftById(shiftId).pipe(
    first(),
    finalize(() => loadingService.end()),
  );
};
